import React from "react";
import { GlobalTableStyles } from './globalTableStyles'
import { NoteTableHeaderList, QuestionDetails } from "../../../Models/applicationModels";
import DeclineDetailsRow from "./declineDetailsRow";
import { declineDetailsTableHeaderList } from "../../../constants/tableHeaderList";

interface IGlobalTableProps {
    tableData: QuestionDetails[]
}

const DeclineDetailsTable = (props: IGlobalTableProps) => {
    const { tableData } = props

    const {
        tableStyle,
        tableHeader,
    } = GlobalTableStyles().classes

    return (
        <>
            <table className={tableStyle}>
                <tr>
                    {declineDetailsTableHeaderList?.map((header: NoteTableHeaderList) => {
                        return (
                            <th
                                className={tableHeader}
                                style={{ width: header.width }}
                            >
                                {header.headerName}
                            </th>
                        )
                    })}
                </tr>
                {tableData?.length > 0 && (
                    <>
                        <DeclineDetailsRow data={tableData} parentIndex={""} />
                    </>
                )
                }
            </table>
        </>
    )
}

export default DeclineDetailsTable